import { CREATEDUTYROSTER, CREATEDUTYROSTERASSIGN, CREATEDUTYROSTERSHIFT, DELETEDUTYROSTER, DELETEDUTYROSTERASSIGN, DELETEDUTYROSTERSHIFT, GETDUTYROSTER, GETDUTYROSTERASSIGN, GETDUTYROSTERSHIFT, UPDATEDUTYROSTER, UPDATEDUTYROSTERASSIGN, UPDATEDUTYROSTERSHIFT } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEDUTYROSTERSHIFT:
            return {
                ...state,
                dutyrostershiftSaveStatus: action.payload.success,
            }
        case GETDUTYROSTERSHIFT:
            return {
                ...state,
                dutyrostershiftList: action.payload.data || [],
            }
        case UPDATEDUTYROSTERSHIFT:
            return {
                ...state,
                dutyrostershiftUpdateStatus: action.payload.success,
            }

        case DELETEDUTYROSTERSHIFT:
            return {
                ...state,
                dutyrostershiftDeleteStatus: action.payload.success,
            }
        case CREATEDUTYROSTER:
            return {
                ...state,
                dutyrosterSaveStatus: action.payload.success,
            }
        case GETDUTYROSTER:
            return {
                ...state,
                dutyrosterList: action.payload.data,
            }
        case UPDATEDUTYROSTER:
            return {
                ...state,
                dutyrosterUpdateStatus: action.payload.success,
            }

        case DELETEDUTYROSTER:
            return {
                ...state,
                dutyrostertDeleteStatus: action.payload.success,
            }
        case CREATEDUTYROSTERASSIGN:
            return {
                ...state,
                dutyrosterassignSaveStatus: action.payload.success,
            }
        case GETDUTYROSTERASSIGN:
            return {
                ...state,
                dutyrosterassignList: action.payload.data || [],
            }
        case UPDATEDUTYROSTERASSIGN:
            return {
                ...state,
                dutyrosterassignUpdateStatus: action.payload.success,
            }

        case DELETEDUTYROSTERASSIGN:
            return {
                ...state,
                dutyrosterassignDeleteStatus: action.payload.success,
            }
        default:
            return state
    }
}